// extracted by mini-css-extract-plugin
export default {"positionCenter":"Error_positionCenter__7x3Lf"};